var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"print-tag"},[_c('transition',{attrs:{"name":_vm.effect,"mode":"out-in"}},[(_vm.toggle.nonSegregatedBatchList)?_c('print-labels'):_c('print-tag-main-view')],1)],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }